// core
import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';

// services
import { UserCanService } from '../../services/user-can.service';

// API
import {
    Status,
    OperationListOperation,
    OperationCommentClient,
} from "../../WebApiClient";

// assets
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { TerminalOperationLogbookComponent } from '../operation-logbook/operation-logbook.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-operation-list',
  standalone: false,
  templateUrl: './operation-list.component.html',
  styleUrl: './operation-list.component.scss',
  providers: [OperationCommentClient]
})
export class OperationListComponent{
  /** OperationList title to display */
  @Input() public listTitle = '';
  /** OperationList Status type to display */
  @Input() public listType: Status | undefined = undefined;
  /** Operation list to display */
  @Input() public operationList: OperationListOperation[] | [] = [];
  /** Curreng (global) user rights */
  @Input() public rights: {[key: string]: boolean} = {};
  
  @Output() editOperationEvent = new EventEmitter<string>();
  @Output() copyOperationEvent = new EventEmitter<string>();
  @Output() acceptOperationEvent = new EventEmitter<string>();
  @Output() operationResourcesEvent = new EventEmitter<{selectedOperationId: string, tab: string}>();
  @Output() updateOperationStatusEvent = new EventEmitter<{ selectedOperationId: string, newOperationStatus: Status }>();
  @Output() removeOperationEvent = new EventEmitter<OperationListOperation>();
  @Output() rejectOperationEvent = new EventEmitter<string>();

  readonly faDelete = faTrashAlt;
  public operationStatuses = Status;

  public otherLocationName = "... other";
  public hideStatusColumn: boolean = false;

  public editOperation(id: string) {
    if(this.userCan.editOperation(this.listType)) {this.editOperationEvent.emit(id);}
  };
  public copyOperation(id: string) {
    if(this.userCan.copyOperation(this.listType)) {this.copyOperationEvent.emit(id);}
  };
  public acceptOperation(id: string) {
    if(this.userCan.acceptOperation(this.listType)) {this.acceptOperationEvent.emit(id);}
  };
  public operationResources(selectedOperationId: string, tab: string = 'vehicle') {
    this.operationResourcesEvent.emit({selectedOperationId, tab});
  };
  public updateOperationStatus(selectedOperationId: string, newOperationStatus: Status) {
    if(this.userCan.updateOperationStatus(this.listType)) {this.updateOperationStatusEvent.emit({selectedOperationId, newOperationStatus})};
  };
  public removeOperation(operation: OperationListOperation) {
    if(this.userCan.deleteOperation(this.listType)) {this.removeOperationEvent.emit(operation);}
  };
  public rejectOperation(id: string) {
    this.rejectOperationEvent.emit(id);
  };

  public constructor (
    public readonly userCan: UserCanService,
    private readonly modalService: NgbModal,
    private readonly operationCommentClient: OperationCommentClient
  ) {}

    ngOnInit(): void {
        this.hideStatusColumn = this.listType === 'Pending';
    }

    get sortedOperations(): OperationListOperation[] {
        return [...this.operationList].sort((a, b) => {
            const aDate = new Date(a.startDateTime.dateTime).getTime();
            const bDate = new Date(b.startDateTime.dateTime).getTime();
            return aDate - bDate;
        });
    }

    get canRejectOperation(): boolean {
        return this.userCan.canRejectOperation;
    }

    public async openLogbook(operation: OperationListOperation): Promise<void> {

        TerminalOperationLogbookComponent.open(
            this.modalService,
            operation.id
        );

        await this.markCommentsAsRead(operation);
        operation.hasUnreadComments = false;
    }

    public async markCommentsAsRead(operation: OperationListOperation): Promise<void> {

        if (!operation!.id) {
            return;
        }

        try {

            await this.operationCommentClient
                .markCommentsAsRead(operation!.id)
                .toPromise();

            operation.hasUnreadComments = false;

        }
        catch (error) {

            console.error(error);

        }
    }
}
